import { useEffect, useState } from 'react';

const useMonetateLoaded = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    if (!loaded) {
      const now = Date.now();
      interval = setInterval(() => {
        const timePast = Date.now();
        if (typeof window !== 'undefined') {
          if (window.monetate) {
            setLoaded(true);
            clearInterval(interval);
          }
        }
        // Clear interval after 5 seconds in case monetate doesn't ever load
        if (timePast - now > 5 * 1000) {
          setLoaded(true);
          clearInterval(interval);
        }
      }, 50);
    }

    return () => {
      clearInterval(interval);
    };
  }, [loaded]);

  return loaded;
};

export default useMonetateLoaded;

declare global {
  interface Window {
    monetate: any;
  }
}
